// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

const ProductTag = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 123.1 800 585" {...props}>
    <path
      fill="#CCC"
      d="M746.3 511.3L243.1 648.5c-3.3.9-6.8.3-9.6-1.7L62.7 525.4c-4.5-3.2-6.1-9.2-3.7-14.2l87.1-185.6c1.4-3 4.1-5.3 7.3-6.2l503.1-137.2c6.1-1.7 12.4 1.9 14 8l83.7 307c.8 2.9.4 6-1.1 8.7-1.4 2.7-3.9 4.6-6.8 5.4z"
    />
    <path
      fill="#FFF"
      d="M752.7 473.3l-528.1 144L45.3 489.9l91.4-194.8 528.1-144"
    />
    <circle fill="#E7E7E7" cx="161.2" cy="456.9" r="30.7" />
    <path
      fill="#808283"
      d="M755.9 484.9l-528.1 144c-3.5.9-7.2.3-10.1-1.8L38.4 499.7c-4.7-3.4-6.4-9.6-3.9-14.9L125.9 290c1.5-3.2 4.3-5.6 7.7-6.5l528.1-144c6.4-1.7 13 2 14.7 8.4l87.9 322.2c.8 3.1.4 6.3-1.2 9.1s-4.2 4.8-7.2 5.7zm-529 119.3l511-139.3-81.6-299.1-511.1 139.4-84.7 180.7 166.4 118.3z"
    />
  </svg>
);

export default ProductTag;



// WEBPACK FOOTER //
// ./src/components/Icons/ProductTag.js